// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"199":"557a3091","529":"990a0e7b"}[chunkId] + ".chunk.js";
};